/**
 * Which environments show the procedure-template Export action (z8nrz7dz4g).
 *
 * Bundles are authored in dev and staging and promoted forward, so only those
 * builds export; production imports but never exports. Set at build time by
 * `VITE_PROCEDURE_TEMPLATE_EXPORT_ENABLED` in the deploy workflows. Opt-in:
 * only the exact string "true" enables it, so a build that never states it
 * (prod, or a new environment) has no Export button.
 *
 * This only hides the control. The API enforces the same rule on its own
 * (`PROCEDURE_TEMPLATE_EXPORT_ENABLED`, 403), so the two flags must agree per
 * environment. Import is never gated.
 */
export function parseTemplateExportEnabled(raw: string | undefined): boolean {
  return raw === 'true'
}

export const templateExportEnabled = parseTemplateExportEnabled(
  import.meta.env.VITE_PROCEDURE_TEMPLATE_EXPORT_ENABLED,
)
